// here we store all constants data
export const PATH = '/api/v1/';